var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.text_apply) + " ")]), _c('span', [_vm._v(" " + _vm._s(_vm.text_grant) + " ")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }